/* import __COLOCATED_TEMPLATE__ from './project-details-deliverables.hbs'; */
import Component from '@glimmer/component';

const CLASS_NAME = 'SH-c-project-details-deliverables';

class ProjectDetailsDeliverables extends Component {
  get className() {
    return CLASS_NAME;
  }

  get deliverables() {
    const { application } = this.args;

    // determine whether to use memorialized version
    return application.applicationDetails
      ? application.applicationDeliverables
      : application.assignment.assignmentDeliverables;
  }

  get scheduleItems() {
    const { application } = this.args;

    // determine whether to use memorialized version
    return application.applicationDetails
      ? application.scheduleItems
      : application.assignment.scheduleItems;
  }
}

export default ProjectDetailsDeliverables;
